import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminLeads } from "../../lib/api";

const STATUSES = ["All", "New", "Contacted", "Quoted", "Confirmed", "Flown", "Lost"];

export default function AdminLeads() {
  const nav = useNavigate();
  const [rows, setRows] = useState([]);
  const [status, setStatus] = useState("All");
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  const load = () => { setLoading(true); adminLeads({ status, q }).then((r) => { setRows(r); setLoading(false); }).catch(() => setLoading(false)); };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [status]);

  const fmt = (iso) => { try { return new Date(iso).toLocaleString("en-IN", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" }); } catch { return iso; } };

  return (
    <div>
      <h1 className="adm-h1">Leads</h1>
      <p className="adm-sub">Every request from the website lands here.</p>
      <div className="adm-tools">
        <input placeholder="Search name, phone, route…" value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && load()} />
        <select value={status} onChange={(e) => setStatus(e.target.value)}>{STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}</select>
        <button className="adm-btn" type="button" onClick={load}>Search</button>
      </div>
      <div className="panel" style={{ padding: 6 }}>
        <table className="tbl">
          <thead><tr><th>Ref</th><th>Received</th><th>Name</th><th>Route</th><th>Date</th><th>Pax</th><th>Status</th></tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} onClick={() => nav(`/admin/leads/${r.id}`)}>
                <td style={{ fontWeight: 800 }}>{r.reference}</td>
                <td>{fmt(r.created_at)}</td>
                <td>{r.name}<div style={{ color: "var(--muted)", fontSize: 12 }}>{r.phone}</div></td>
                <td>{r.from_city} {"\u2192"} {r.to_city}</td>
                <td>{r.date || "\u2014"}</td>
                <td>{r.passengers || "\u2014"}</td>
                <td><span className={"pill " + r.status}>{r.status}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
        {!loading && !rows.length ? <p className="adm-sub" style={{ padding: 16 }}>No leads found. Submit a request on the website to see it here.</p> : null}
        {loading ? <p className="adm-sub" style={{ padding: 16 }}>Loading…</p> : null}
      </div>
    </div>
  );
}
